import { Heading, useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type {
  EditOrganizationUnit,
  OrganizationUnit,
  OrganizationUnitProperties,
} from 'BrokerTsLib/src/dtos'
import {
  useCreateOrganizationUnit,
  useGetPossibleTypes,
} from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useState } from 'react'
import { useNavigate } from 'react-router'

import { Container } from '@/components/Container'
import { Section } from '@/components/Section'
import { OrganizationEditForm } from '@/containers/organization/OrganizationEditForm'
import { PageContent } from '@/containers/PageContent'

export const OrganizationCreatePage = () => {
  const navigate = useNavigate()
  const toast = useToast()

  const [organization] = useState({} as OrganizationUnit)
  const [properties] = useState({} as OrganizationUnitProperties)

  const { mutateAsync: create } = useCreateOrganizationUnit()
  const { data } = useGetPossibleTypes()
  const possibleTypes = Array.from(new Set(data?.data ?? []))

  const onSubmit = (values: EditOrganizationUnit) =>
    create(values)
      .then((response) => {
        navigate('/organization/' + response.data.id)

        return response
      })
      .catch((e: AxiosError) => {
        toast({
          title: 'Chyba při vytváření organizace',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })

        return e
      })

  return (
    <Section>
      <Container>
        <PageContent>
          <Heading>Vytvořit novou organizaci</Heading>

          <OrganizationEditForm
            organization={organization}
            properties={properties}
            onSubmit={onSubmit}
            possibleTypes={possibleTypes}
            isCreate
          />
        </PageContent>
      </Container>
    </Section>
  )
}
